<h2>
  {{ translationService.getGhsClassificationsText() }}
</h2>
@if (ghsClassifications.length) {
  <mat-nav-list>
    @for (
      classification of ghsClassifications;
      track classification;
      let i = $index;
      let last = $last
    ) {
      <a
        mat-list-item
        (keydown)="commonService.onKeydown($event, i)"
        [attr.tabindex]="i === 0 ? 0 : -1"
      >
        <div class="ghs-item">
          <span class="bold">{{ classification.name }}</span>
          <img
            [ngSrc]="getGhsImgPath(classification.name)"
            height="35"
            width="35"
            [alt]="classification.name"
          />
        </div>
      </a>
      @if (!last) {
        <mat-divider></mat-divider>
      }
    }
  </mat-nav-list>
} @else {
  <span>{{ translationService.getNaText() }}</span>
}
